module.exports = __webpack_public_path__ + "img/the_power_zone_logo.5d69e5d1.svg";